import React from 'react';
import { ContainerWithCommonContextMenu } from '../../../_lib/components/ContextMenu';
import { asDraggableContentListItem, useSortableListItem } from '../../../_lib/components/SortableContentList';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { StatusInfoError } from '../../../_lib/components/StatusInfo';
import { ContextMenuButtonProps } from '../../../_lib/components/ContextMenu/partials/ContextMenuButton';
import { CheckBoxParam, Switch } from '../../../_lib/Form2';
import { ContentListItemProps } from '../../../_lib/components/ContentList/parials/ContentListItem';
import { SwitchModifier } from '../../../_lib/Form2/elements/Switch/Switch';
import { StatusInfoModifier } from '../../../_lib/components/StatusInfo/partials/StatusInfo';

type AppLibraryListItemProps = { id: string; modifier?: ContentListItemProps['modifier'] } & CheckBoxParam<any>;

function AppLibraryPersonalListItem(props: AppLibraryListItemProps) {
  const { id } = props;

  const { move, nextItemId, prevItemId, error } = useSortableListItem(id);

  const { t } = useSonTranslation('AppLibrary');

  const contextMenuActions: ContextMenuButtonProps[] = [
    {
      children: t('moveUp'),
      key: 'moveElementUp',
      disabled: !prevItemId,
      onClick: event => {
        event.preventDefault();
        event.stopPropagation();
        if (prevItemId) {
          move(prevItemId);
        }
      },
    },
    {
      children: t('moveDown'),
      key: 'moveElementDown',
      disabled: !nextItemId,
      onClick: event => {
        event.preventDefault();
        event.stopPropagation();
        if (nextItemId) {
          move(nextItemId);
        }
      },
    },
  ];

  return (
    <div className="app-library-personal__list-item">
      <ContainerWithCommonContextMenu
        toolTip={t('manageLink', { name: props.displayName as string })}
        actions={contextMenuActions}
      >
        <Switch param={props} label={props?.displayName as string} modifierLabel={SwitchModifier.POSITION_INHERIT} />
      </ContainerWithCommonContextMenu>
      {error && <StatusInfoError message={t('errorResponse')} modifier={StatusInfoModifier.PADDING_TOP} />}
    </div>
  );
}

export const DraggableAppLibraryPersonalListItem = asDraggableContentListItem(AppLibraryPersonalListItem);
